import styles from "./PortalBody.module.css"
import { useContext, useEffect } from "react";
import { AdminContext } from "../../../../Context/Admin.Context";
import { AuthContext } from "../../../../Context/Auth.Context";


import PortalDashboard from "../../../PortalPages/PortalDashboard/PortalDashboard";

import AllProductsTablePage from "../../../PortalPages/AllProducts/AllProductsTablePage";
import AllUsersTablePage from "../../../PortalPages/AllUsers/AllUsersTablePage";
import AllAdminUsersTablePage from "../../../PortalPages/AllAdminUsers/AllAdminUsersTablePage";
import CreateAdminPortalFormPage from "../../../PortalPages/CreateAdmin/CreateAdminPortalFormPage";
import CreateProductPortalFormPage from "../../../PortalPages/CreateProduct/CreateProductPortalFormPage";
import UpdateProductPortalFormPage from "../../../PortalPages/UpdateProduct/UpdateProductPortalFormPage";
import PortalUpdateUserRoleFormPage from "../../../PortalPages/UpdateUserRole/PortalUpdateUserRoleFormPage";
import PortalUpdateUserStatusFormPage from "../../../PortalPages/UpdateUserStatus/PortalUpdateUserStatusFormPage";
import AnalyticsPage from "../../../PortalPages/Analytics/AnalyticsPage";
import CopyProductPortalFormPage from "../../../PortalPages/CopyProduct/CopyProductPortalFormPage";
import FeatureDefinitionsTablePage from "../../../PortalPages/FeatureDefinitions/FeatureDefinitionsTablePage";
import AddFeatureDefinitionsPage from "../../../PortalPages/FeatureDefinitions/AddFeatureDefinitionsPage";
import UpdateFeatureDefinitionsPage from "../../../PortalPages/FeatureDefinitions/UpdateFeatureDefinitionsPage";

const PortalBody = () => {
     const { token } = useContext(AuthContext);
     const { isActiveSection } = useContext(AdminContext);

     return (

          <div className={styles.portalBodyContainer}>
               <div className={styles.portalContentWrapper}>
                    {
                         isActiveSection === 1 && <PortalDashboard />
                    }
                    {
                         isActiveSection === 3 && <CreateProductPortalFormPage />
                    }
                    {
                         isActiveSection === 4 && <UpdateProductPortalFormPage />
                    }
                    {
                         isActiveSection === 2 && <AllProductsTablePage />
                    }
                    {
                         isActiveSection === 5 && <AllUsersTablePage />
                    }
                    {
                         isActiveSection === 6 && <AllAdminUsersTablePage />
                    }
                    {
                         isActiveSection === 7 && <PortalUpdateUserRoleFormPage />
                    }
                    {
                         isActiveSection === 8 && <CreateAdminPortalFormPage />
                    }
                    {
                         isActiveSection === 9 && <PortalUpdateUserStatusFormPage />
                    }
                    {
                         isActiveSection === 10 && <AnalyticsPage />
                    }
                    {
                         isActiveSection === 11 && <CopyProductPortalFormPage />
                    }
                    {
                         isActiveSection === 12 && <FeatureDefinitionsTablePage />
                    }
                    {
                         isActiveSection === 13 && <AddFeatureDefinitionsPage />
                    }
                    {
                         isActiveSection === 14 && <UpdateFeatureDefinitionsPage />
                    }

               </div>

          </div>

     );
};

export default PortalBody;